// WP-STANDARD | PUBLIC CONTACT CHANNELS
// STATUS: STATIC_PASS · RUNTIME_PENDING
// Single source of truth for public contact destinations. Keep sales/support CTAs
// routed through the contact chooser so channel changes never drift between pages.
export const WEBPROFIT_CALENDLY_URL = "https://calendly.com/montiverogianfranco2709/15min";
export const WEBPROFIT_WHATSAPP_URL = "https://wa.me/message/HOYXZTTFNXNZH1";

export function buildCalendlyEmbedUrl() {
  const params = new URLSearchParams({
    hide_gdpr_banner: "1",
    background_color: "ffffff",
    text_color: "19242f",
    primary_color: "f35a3a",
  });
  return `${WEBPROFIT_CALENDLY_URL}?${params.toString()}`;
}
